import React from 'react';
import PropTypes from 'prop-types';

const QuestionMark = ({ color }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 1024 1024">
    <title />
    <g id="icomoon-ignore" />
    <path
      fill={color}
      d="M512 109.714c-221.743 0-402.286 180.543-402.286 402.286s180.543 402.286 402.286 402.286c221.743 0 402.286-180.543 402.286-402.286s-180.543-402.286-402.286-402.286zM512 182.857c182.214 0 329.143 146.929 329.143 329.143s-146.929 329.143-329.143 329.143c-182.214 0-329.143-146.929-329.143-329.143s146.929-329.143 329.143-329.143z"
    />
    <path
      fill={color}
      d="M512 694.857c-19.981 0-36.571 16.59-36.571 36.571s16.59 36.571 36.571 36.571c19.981 0 36.571-16.59 36.571-36.571s-16.59-36.571-36.571-36.571z"
    />
    <path
      fill={color}
      d="M512 292.571c-80.359 0-146.286 65.927-146.286 146.286h73.143c0-40.832 32.311-73.143 73.143-73.143h3.429c38.926 0 69.714 30.788 69.714 69.714v18.714c0 18.929-11.897 35.442-29.857 41.429-47.561 15.854-79.857 60.725-79.857 110.857v51.857h73.143v-51.857c0-18.929 11.897-35.442 29.857-41.429 47.561-15.854 79.857-60.725 79.857-110.857v-18.714c0-78.454-64.403-142.857-142.857-142.857z"
    />
  </svg>
);

QuestionMark.propTypes = {
  color: PropTypes.string.isRequired,
};

export default QuestionMark;
